<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/reimbursement/banner.png" @click="$login">
    <text-left
        :text-left="{
        height: 410,
        title: '筝鸣，让费用报销变得简单',
        desc: '办公室，再也不是处理费用报销单的唯一场所。无论何时，无论何地，您都可以在云端完成费用报销单的提交和审核，更加绿色，环保，高效。',
        textWidth: 520,
        imgWidth: 430,
        left: true,
        img: require('@/assets/reimbursement/img1.png')
      }"/>
    <text-left
      :text-left="{
        height: 357,
        title: '优化您的费用报销流程',
        desc: '通过提交，审核，追踪所有员工费用报销更好地管理您的内控流程。所有的费用报销信息都在一处显示，只需轻轻一点，便可审核所有的费用报销。',
        textWidth: 540,
        imgWidth: 430,
        left: false,
        img: require('@/assets/reimbursement/img2.png')
      }"/>
    <text-left
      :text-left="{
        height: 430,
        title: '报销凭证上传',
        desc: '您的员工长期在外出差吗？费用报销凭证提交不及时怎么办？不用担心，只需用手机拍照并保存为附件上传到系统，就可以作为财务经理进行审核的凭据。',
        textWidth: 520,
        imgWidth: 400,
        left: true,
        img: require('@/assets/reimbursement/img3.png')
      }"/>
    <part-list :part-list="list" />
    <Ready />
  </div>
</template>

<script>
import Ready from '@/components/Ready'
import PartList from '@/components/PartList'
import TextLeft from '@/components/TextLeft'
export default {
  name: 'Reimbursement',
  components: { Ready, PartList, TextLeft },
  data() {
    return {
      list: [
        {
          img: require('@/assets/common/guding.png'),
          title: '财务检测助手',
          desc: '自动巡检账套，检测常见财务锗误与税务风险',
          path: '/financial'
        },
        {
          img: require('@/assets/common/xiaoshou.png'),
          title: '销售账单管控',
          desc: '跟踪销售账单收款状态，牢牢掌控应收账款',
          path: '/sale'
        },
        {
          img: require('@/assets/common/caigou.png'),
          title: '采购账单管控',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/purchase'
        },
        {
          img: require('@/assets/common/feiyong.png'),
          title: '费用报销管理',
          desc: '员工随时随地登录系统，完成费用报销申请与审批',
          path: '/reimbursement'
        },
        {
          img: require('@/assets/common/guding1.png'),
          title: '固定资产',
          desc: '集中管理，轻松维护您的固定资产',
          path: '/estate'
        }
      ]
    }
  }
}
</script>
<style scoped>

</style>
